import { render, staticRenderFns } from "./imageLoader.vue?vue&type=template&id=4848c089&scoped=true&"
import script from "./imageLoader.vue?vue&type=script&lang=js&"
export * from "./imageLoader.vue?vue&type=script&lang=js&"
import style0 from "./imageLoader.vue?vue&type=style&index=0&id=4848c089&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4848c089",
  null
  
)

export default component.exports